export default __webpack_public_path__ + "static/media/about-img.7f79e088.jpg";